import { render } from "./ObjectListTable.vue?vue&type=template&id=f7d68910"
import script from "./ObjectListTable.vue?vue&type=script&lang=js"
export * from "./ObjectListTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__